var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "Polaris-Banner  Polaris-Banner--withinPage my-2",
      class: {
        "Polaris-Banner--statusCritical": _vm.type === "critical",
        "Polaris-Banner--statusWarning": _vm.type === "warning"
      },
      attrs: { tabindex: "0", role: "alert", "aria-live": "polite" }
    },
    [
      _c(
        "div",
        {
          staticClass: "Polaris-Box",
          staticStyle: { "--pc-box-padding-inline-end-xs": "var(--p-space-4)" }
        },
        [
          _c(
            "span",
            {
              staticClass:
                "Polaris-Icon Polaris-Icon--colorCritical Polaris-Icon--applyColor",
              class: {
                "Polaris-Icon--colorCritical": _vm.type === "critical",
                "Polaris-Icon--colorWarning": _vm.type === "warning"
              }
            },
            [
              _c("span", {
                staticClass: "Polaris-Text--root Polaris-Text--visuallyHidden"
              }),
              _c(
                "svg",
                {
                  staticClass: "Polaris-Icon__Svg",
                  attrs: {
                    viewBox: "0 0 20 20",
                    focusable: "false",
                    "aria-hidden": "true"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M11.768.768a2.5 2.5 0 0 0-3.536 0l-7.464 7.464a2.5 2.5 0 0 0 0 3.536l7.464 7.464a2.5 2.5 0 0 0 3.536 0l7.464-7.464a2.5 2.5 0 0 0 0-3.536l-7.464-7.464zm-2.768 5.232a1 1 0 1 1 2 0v4a1 1 0 1 1-2 0v-4zm2 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
                    }
                  })
                ]
              )
            ]
          )
        ]
      ),
      _c("div", { staticClass: "Polaris-Banner__ContentWrapper" }, [
        _c(
          "h2",
          { staticClass: "Polaris-Text--root Polaris-Text--headingMd" },
          [
            _c("span", [
              _vm._v(_vm._s(_vm.type === "warning" ? "Warning" : "Error"))
            ])
          ]
        ),
        _c(
          "div",
          {
            staticClass: "Polaris-Box",
            staticStyle: {
              "--pc-box-padding-block-end-xs": "var(--p-space-05)",
              "--pc-box-padding-block-start-xs": "var(--p-space-05)"
            }
          },
          [_c("p", [_vm._v(" " + _vm._s(_vm.text) + " ")])]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }